import { render } from "./InteractionMenu.vue?vue&type=template&id=09674029&scoped=true&ts=true"
import script from "./InteractionMenu.vue?vue&type=script&lang=ts"
export * from "./InteractionMenu.vue?vue&type=script&lang=ts"

import "./InteractionMenu.vue?vue&type=style&index=0&id=09674029&lang=less&scoped=true"

import exportComponent from "/home/jenkins_home/workspace/c1-02_dwart2.0-apkpc-site/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09674029"]])

export default __exports__